module.exports = __webpack_public_path__ + "static/img/logo.5f22bb16.svg";